module.exports = __webpack_public_path__ + "img/team-hero-f1309d7.jpg";